import React, { createElement, Fragment, useCallback } from 'react';
import ProCard from '@/components/layout/pro-card';
import { Field, Table, Form, Button, ResponsiveGrid, Input, Select, TreeSelect } from '@alifd/next';
import { isEmpty } from 'lodash-es';
import { nanoid } from 'nanoid';
import { useDeepCompareEffect } from 'ahooks';
const ServiceOutTable = (props) => {
    const { data, blockProps, isPreview, isDesign, spacing, columns, serviceUid, jsonSchemaTreeData, serviceId, field, getOutTable, reqServiceMapperList } = props;
    const [dataSource, setDataSource] = React.useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
    const columnsTables = [
        {
            title: '服务配置实体属性',
            dataIndex: 'targetParam',
            width: 300,
        },
        {
            title: '数据来源',
            dataIndex: 'dataSrcCd',
            width: 300,
            cell: (val) => {
                const dataSrcCdEnums = {
                    '900800000040': '源请求实体参数',
                    '900800000030': '上下文参数',
                    '900800000050': '固定值'
                };
                return createElement("span", null, dataSrcCdEnums[val]);
            }
        },
        {
            title: '数据对象',
            dataIndex: 'sourceParam',
            width: 300,
        },
    ];
    const queryReplaceData = (data = []) => {
        const replaceData = data.map(item => {
            const { sourceParam } = item;
            if (!isEmpty(sourceParam)) {
                const replaceValue = sourceParam.replace('{}', '').replace(/({\w+})/, (match) => {
                    const index = match.slice(1, -1);
                    return `[].${index}`;
                });
                return {
                    ...item,
                    sourceParam: replaceValue
                };
            }
            return item;
        });
        return replaceData;
    };
    const formField = Field.useField({
        parseName: true,
    });
    useDeepCompareEffect(() => {
        if (!isEmpty(data)) {
            setDataSource(data);
            getOutTable(data);
        }
    }, [data]);
    const onRowChange = useCallback((selectedRowKeys, records) => {
        setSelectedRowKeys(selectedRowKeys);
        setSelectedRows(records);
        const { sourceParam, dataSrcCd } = records[0] || {};
        formField.setValues({
            ...records[0],
            sourceParam: sourceParam ?? '',
            dataSrcCd: dataSrcCd ?? '',
        });
    }, [formField]);
    const rowSelection = {
        mode: 'single',
        onChange: onRowChange,
        selectedRowKeys,
        getProps: () => {
            return {
                disabled: isDesign || isPreview,
            };
        },
    };
    const onChange = async (val, dataIndex) => {
        const newData = dataSource.map((item = {}) => {
            if (item._uid === selectedRowKeys[0]) {
                const updateItem = { ...item };
                updateItem[dataIndex] = val;
                return updateItem;
            }
            return item;
        });
        const replaceData = queryReplaceData(newData);
        setDataSource(replaceData);
        getOutTable(replaceData);
        if (dataIndex === 'dataSrcCd') {
            formField.setValue('sourceParam', '');
        }
    };
    const submit = () => {
        formField.validate((errors, values) => {
            if (isEmpty(errors)) {
                const newData = dataSource.map((item = {}) => {
                    if (item.uid === selectedRowKeys[0]) {
                        return { ...values };
                    }
                    return item;
                });
                const replaceData = queryReplaceData(newData);
                setDataSource(replaceData);
                const accEventServiceCfgList = field.getValue('accEventServiceCfgList') ?? [];
                const updateAccEventServiceCfgList = accEventServiceCfgList.map(item => {
                    if (serviceId === item.id || serviceUid === item.uid) {
                        return {
                            ...item,
                            reqServiceMapperList,
                            resServiceMapperList: newData
                        };
                    }
                    return item;
                });
                field.setValue('accEventServiceCfgList', updateAccEventServiceCfgList);
                resetSelectedRows();
            }
        });
    };
    const resetSelectedRows = () => {
        setSelectedRowKeys([]);
        setSelectedRows([]);
    };
    const cancle = () => {
        resetSelectedRows();
    };
    return (createElement(Fragment, null,
        createElement(ProCard, { ...blockProps, title: '\u670D\u52A1\u51FA\u53C2\u6620\u5C04' },
            createElement("div", null,
                createElement(Table, { dataSource: dataSource, columns: columnsTables, rowSelection: rowSelection, primaryKey: "_uid" }),
                ((isDesign || selectedRows.length > 0) && !isPreview) && (createElement(Form, { isPreview: isPreview, field: formField, useLabelForErrorMessage: true, labelAlign: "left", fullWidth: false },
                    createElement(ResponsiveGrid, { gap: spacing, columns: columns },
                        createElement(Form.Item, { labelAlign: "left", label: "\u670D\u52A1\u914D\u7F6E\u5B9E\u4F53\u5C5E\u6027", name: "targetParam", size: "medium", fullWidth: true },
                            createElement(Input, { placeholder: "\u8BF7\u8F93\u5165", size: "medium", disabled: true })),
                        createElement(Form.Item, { labelAlign: "left", label: "\u6570\u636E\u6765\u6E90", name: "dataSrcCd", size: "medium", fullWidth: true, required: true },
                            createElement(Select, { placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u6765\u6E90", size: "medium", dataSource: [
                                    { label: '源请求实体参数', value: '900800000040' },
                                ], onChange: (val) => onChange(val, 'dataSrcCd') })),
                        createElement(Form.Item, { labelAlign: "left", label: "\u6570\u636E\u5BF9\u8C61", name: "sourceParam", size: "medium", fullWidth: true, required: true },
                            createElement(TreeSelect, { placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u5BF9\u8C61", size: "medium", dataSource: jsonSchemaTreeData, showSearch: true, hasClear: true, onChange: (val) => onChange(val, 'sourceParam') }))),
                    isPreview ? null : (createElement("div", { style: { textAlign: 'center' } },
                        createElement(Button.Group, null,
                            createElement(Button, { type: "primary", key: nanoid(), onClick: submit, disabled: isDesign }, "\u4FDD\u5B58"),
                            createElement(Button, { onClick: cancle }, "\u53D6\u6D88"))))))))));
};
export default ServiceOutTable;
